import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/navbar.tsx';
import Footer from './components/footer.tsx';
import ScrollToTop from './components/ScrollToTop.tsx';
import Home from './pages/home/home.tsx';
import Login from './pages/login.tsx';
import Register from './pages/register.tsx';
import ForgotPassword from './pages/forgot-password.tsx';
import ResetPassword from './pages/reset-password.tsx';
import OAuthCallback from './pages/oauth-callback.tsx';
import Dashboard from './pages/dashboard/Dashboard.tsx';
import Profile from './pages/profile.tsx';
import Plans from './pages/plans/Plans.tsx';
import Features from './pages/features.tsx';
import Pricing from './pages/pricing.tsx';
import Checkout from './pages/checkout.tsx';
import About from './pages/about.tsx';
import Contact from './pages/contact.tsx';
import Security from './pages/security.tsx';
import AdminPage from './pages/admin/AdminPage.tsx';
import AdminRoute from './components/AdminRoute.tsx';
import PrivateRoute from './components/PrivateRoute.tsx';
import DashboardLayout from './layouts/DashboardLayout.tsx';
import AgendaPool from './pages/agenda-pool/AgendaPool.tsx';
import MeetingRoute from './pages/meeting/components/MeetingRoute.tsx';
import RecordingsPage from './pages/recordings/RecordingsPage.tsx';
import SummariesPage from './pages/summaries/SummariesPage.tsx';
import WhiteboardsPage from './pages/whiteboards/WhiteboardsPage.tsx';
import WhiteboardEditorPage from './pages/whiteboards/WhiteboardEditorPage.tsx';
import NotesPage from './pages/notes/NotesPage.tsx';
import NoteEditorPage from './pages/notes/NoteEditorPage.tsx';
import CalendarPage from './pages/calendar/CalendarPage.tsx';
import GoogleCalendarCallback from './pages/calendar/GoogleCalendarCallback.tsx';

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

function AppContent() {
  const location = useLocation();
  
  // Navbar gösterilmeyecek sayfalar
  const hideNavbar = location.pathname.startsWith('/meeting/') ||
                     location.pathname === '/login' ||
                     location.pathname === '/register' ||
                     location.pathname === '/forgot-password' ||
                     location.pathname.startsWith('/reset-password') ||
                     location.pathname === '/oauth/callback';

  // Footer gösterilmeyecek sayfalar
  const hideFooter = location.pathname.startsWith('/meeting/') ||
                     location.pathname === '/login' ||
                     location.pathname === '/register' ||
                     location.pathname === '/forgot-password' ||
                     location.pathname.startsWith('/reset-password') ||
                     location.pathname === '/oauth/callback';

  return (
    <div className="min-h-screen flex flex-col text-white">
      <ScrollToTop />
      {!hideNavbar && <Navbar />}
      
      <div className="flex-1">
        <Routes>
          {/* Public - Layout yok */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/oauth/callback" element={<OAuthCallback />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/checkout" element={
            <PrivateRoute>
              <Checkout />
            </PrivateRoute>
          } />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/security" element={<Security />} />

          {/* Private - Dashboard Layout */}
          <Route path="/admin" element={
            <AdminRoute>
              <DashboardLayout><AdminPage /></DashboardLayout>
            </AdminRoute>
          } />
          <Route path="/dashboard" element={
            <PrivateRoute>
              <DashboardLayout><Dashboard /></DashboardLayout>
            </PrivateRoute>
          } />
          <Route path="/profile" element={
            <PrivateRoute>
              <DashboardLayout><Profile /></DashboardLayout>
            </PrivateRoute>
          } />
          <Route path="/plans" element={
            <PrivateRoute>
              <DashboardLayout><Plans /></DashboardLayout>
            </PrivateRoute>
          } />
          <Route path="/recordings" element={
            <PrivateRoute>
              <DashboardLayout><RecordingsPage /></DashboardLayout>
            </PrivateRoute>
          } />
          <Route path="/summaries" element={
            <PrivateRoute>
              <DashboardLayout><SummariesPage /></DashboardLayout>
            </PrivateRoute>
          } />
          <Route path="/agenda-pool" element={
            <PrivateRoute>
              <DashboardLayout><AgendaPool /></DashboardLayout>
            </PrivateRoute>
          } />
          <Route path="/calendar" element={
            <PrivateRoute>
              <DashboardLayout><CalendarPage /></DashboardLayout>
            </PrivateRoute>
          } />
          <Route path="/calendar/google/callback" element={
            <PrivateRoute>
              <GoogleCalendarCallback />
            </PrivateRoute>
          } />
          <Route path="/products/whiteboards" element={
            <PrivateRoute>
              <DashboardLayout><WhiteboardsPage /></DashboardLayout>
            </PrivateRoute>
          } />
          <Route path="/products/whiteboards/:id" element={
            <PrivateRoute>
              <DashboardLayout><WhiteboardEditorPage /></DashboardLayout>
            </PrivateRoute>
          } />
          <Route path="/products/notes" element={
            <PrivateRoute>
              <DashboardLayout><NotesPage /></DashboardLayout>
            </PrivateRoute>
          } />
          <Route path="/products/notes/:id" element={
            <PrivateRoute>
              <DashboardLayout><NoteEditorPage /></DashboardLayout>
            </PrivateRoute>
          } />

          {/* Meeting - Misafir veya Kayıtlı Kullanıcı */}
          <Route path="/meeting/:id" element={<MeetingRoute />} />
        </Routes>
      </div>

      {/* Footer - her zaman tam genişlik */}
      {!hideFooter && <Footer />}
    </div>
  );
}

export default App;